import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExportExcelButtonComponent } from 'src/app/common/components/export-excel-button/export-excel-button.component';

@Component({
  selector: 'app-view-group',
  templateUrl: './view-group.component.html',
  styleUrls: ['./view-group.component.scss']
})
export class ViewGroupComponent implements OnInit {
  @ViewChild('viewGroupExportRef') viewGroupExportRef!: ExportExcelButtonComponent;
  groupId = '';
  groupName = '';
  groupType = '';
  regulatoryGroup = '';
  division = '';
  substanceTableData: any[] = [];
  substanceTableColumns: any[] = [];
  exportColumns: any[] = [];
  loading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private matSnackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.groupId = params['id'];
    });
    this.route.queryParams.subscribe(params => {
      this.groupName = params['groupName'] || '';
      this.groupType = params['groupType'] || 'Regulatory Group';
      this.division = params['division'] || 'BPC';
      this.regulatoryGroup = 'Regulatory Group';
    });
    this.initializeTableColumns();

    const navigation = this.router.getCurrentNavigation();
    const stateData = navigation && navigation.extras && navigation.extras.state
      ? navigation.extras.state['substanceTableData']
      : null;
    const historyStateData = window.history && window.history.state
      ? window.history.state.substanceTableData
      : null;

    if (Array.isArray(stateData) && stateData.length > 0) {
      this.substanceTableData = stateData;
    } else if (Array.isArray(historyStateData) && historyStateData.length > 0) {
      this.substanceTableData = historyStateData;
    } else {
      this.substanceTableData = [];
    }
  }

  initializeTableColumns(): void {
    this.substanceTableColumns = [
      { field: 'pureCode', header: 'PURE Code', width: '110px' },
      { field: 'sirId', header: 'SIR ID', width: '120px' },
      { field: 'inciName', header: 'INCI Name', width: '160px' },
      { field: 'cas', header: 'CAS#', width: '105px' },
      { field: 'parentCAS', header: 'Parent CAS#', width: '110px' },
      { field: 'ins', header: 'INS#', width: '95px' },
      { field: 'einecs', header: 'EINECS', width: '95px' },
      { field: 'synonyms', header: 'Synonyms', width: '170px' },
      { field: 'cfData', header: 'CF Data', width: '200px' },
      { field: 'notifySers', header: 'Notify SERS', width: '95px' },
      { field: 'notifySir', header: 'Notify SIR', width: '95px' }
    ];
    this.exportColumns = this.substanceTableColumns.map((column: any) => ({
      field: column.field,
      header: column.header
    }));
  }

  onEditGroup(): void {
    this.router.navigate(['/administration/regulatory-group-master/edit-group', this.groupId], {
      queryParams: {
        groupName: this.groupName,
        groupType: this.groupType,
        division: this.division
      }
    });
  }

  onExport(): void {
    if (!this.substanceTableData || this.substanceTableData.length === 0) {
      this.matSnackBar.open('No records available to export', 'close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }

    if (this.viewGroupExportRef) {
      this.viewGroupExportRef.exportToExcel();
    }
  }

  onBack(): void {
    this.router.navigate(['/administration/regulatory-group-master']);
  }
}
